import { render, staticRenderFns } from "./TicketsMarket.vue?vue&type=template&id=798aa340&"
import script from "./TicketsMarket.vue?vue&type=script&lang=js&"
export * from "./TicketsMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports